module.exports = __webpack_public_path__ + "img/BOX_clues.c39249ba.png";